import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import { ZakekeEnvironment, ZakekeProvider } from '@zakeke/zakeke-configurator-react';

const zakekeEnvironment = new ZakekeEnvironment();

const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);
// const allParameters = Array.from(urlParams.entries());

// Convert allParameters [key, value] to object
// const queryParameters = Object.fromEntries(allParameters) as BootParameters;

// Add dam viewer styles
if (urlParams.get('dam') === 'true') {
	document.body.classList.add('dam-viewer');
}

// Test
//(window as any).Zakeke.config.baseApiUrl = 'https://localhost:44365/api/';

// function parseJwt(token: string) {
// 	var base64Url = token.split('.')[1];
// 	var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
// 	var jsonPayload = decodeURIComponent(
// 		window
// 			.atob(base64)
// 			.split('')
// 			.map(function (c) {
// 				return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
// 			})
// 			.join('')
// 	);

// 	return JSON.parse(jsonPayload);
// }

const Viewer = () => {

	return (
		<ZakekeProvider environment={zakekeEnvironment}>
			<App />
		</ZakekeProvider>
	);
};

// Error boundary
class ErrorBoundary extends React.Component<{ children: React.ReactNode }, { hasError: boolean; error: string }> {
	state = { hasError: false, error: '' };

	static getDerivedStateFromError() {
		console.log('Error');
		return { hasError: true };
	}

	componentDidCatch(error: any, errorInfo: any) {
		// You can also log the error to an error reporting service
		this.setState({ error: error.toString() });
		console.log(error, errorInfo);
	}

	render() {
		if (this.state.hasError) {
			return <div>{this.state.error || 'Something went wrong.'}</div>;
		}

		return this.props.children;
	}
}

const rootElement = document.getElementById('root');
if (rootElement) {
	const root = createRoot(rootElement);
	root.render(
		<React.StrictMode>
			<ErrorBoundary>
				<Viewer />
			</ErrorBoundary>
		</React.StrictMode>
	);
}
